export const routes = {
  home: "/",
  onboarding: {
    home: "/onboarding",
    student: "/onboarding/student-onboarding",
    adult: "/onboarding/adult-onboarding",
  },
  user: {
    home: "/user",
    userProfile: (userId: number | string) => `/user/${userId}`,
    register: "/user/register",
    registerEmail: "/user/register/email",
    registerSocial: "/user/register/social-media",
    forgotPassword: "/user/forgot-password",
    resendEmail: "/user/resend-email",
    login: "/user/login",
    logout: "/user/logout",
    affiliate: (userId: string | number) => `/user/affiliate`,
  },
  courses: {
    home: "/courses", // index.tsx = "Discover Courses" page
    singleCourse: (courseSlug: string) => `/courses/${courseSlug}`,
    chapters: (courseSlug: string) => `/courses/${courseSlug}/chapters`,
    notes: (courseSlug: string) => `/courses/${courseSlug}/notes`,
    files: (courseSlug: string) => `/courses/${courseSlug}/files`,
    discussions: (courseSlug: string) => `/courses/${courseSlug}/discussions`,
    singleLesson: (lessonSlug: string, courseSlug: string) =>
      `/courses/${courseSlug}/${lessonSlug}`,
    myCourses: "/my-courses",
    schoolCourses: "/school-courses",
    filter: "/courses/filter",
  },
  categories: {
    singleCategory: (categorySlug: string) => `/category/${categorySlug}`,
  },
  exercises: {
    home: "/exercises", // index.tsx = "Logic Exercises" page
    set: (bundleId: string) => `/exercises/set/${bundleId}`,
    bundle: `/exercises/bundle`,
    school: "/custom-exercises?type=school",
    personalDevelopment: "/custom-exercises?type=personal_development",
    history: "/exercises/history",
  },
  reels: {
    home: "/reels",
    singleReel: (reelSlug: string) => `/reels/${reelSlug}`,
  },
  marketplace: {
    home: "/marketplace",
    collection: (collectionSlug: string) => `/marketplace/${collectionSlug}`,
    nft: (collectionSlug: string, nftSlug: string) =>
      `/marketplace/${collectionSlug}/${nftSlug}`,
  },
  subscriptions: {
    home: "/subscriptions", // index.tsx = "Info" page
    history: "/subscriptions/history",
    wallet: "/subscriptions/wallet",
    mySubscriptions: "/subscriptions/my-subscriptions",
    myVouchers: "/subscriptions/vouchers",
  },
  settings: "/settings",
  downloads: "/downloads",
  createNFT: {
    home: "/create-nft", // index.tsx = "Create NFT" page
    history: "/create-nft/history",
  },
  messages: "/messages",
  myGroups: "/my-groups",
  faq: "/faq",
  contact: "/contact",
  legals: "/termeni-si-conditii",
  notifications: "/notifications",
  search: "/search",
  transferAsset: "/transfer-asset",
  store: {
    home: "/store",
    orderStatus: "/store/order-status",
    checkout: "/store/checkout",
  },
  webinar: {
    home: "/webinars",
    detail: (slug: string) => `/webinars/${slug}`,
  },
  bugReport: "/bug-report",
  crm: {
    home: "/crm",
    campaign: (slug: string) => `/crm/${slug}`, //index.tsx = tasks page
    reports: (campaignSlug: string) => `/crm/${campaignSlug}/reports`,
    members: (campaignSlug: string) => `/crm/${campaignSlug}/members`,
    personalReport: (campaignSlug: string) =>
      `/crm/${campaignSlug}/personal-report`,
    contacts: "/crm/contacts",
    orderReports: "/crm/reports/orders",
  },
  competition: (slug: string) => `/competition/${slug}`,
  team: (slug: string) => `/team/${slug}`,
  interests: "/interests",
};

export default routes;
